import {defineStore} from 'pinia'
import {ref, unref} from 'vue'

/**
 * Data store
 */
export const useDataStore = defineStore('data', () => {

  //Refs
  const organization = ref(null)
  const user = ref(null)

  //Mutators
  const setOrganization = value => organization.value = unref(value)
  const setUser = value => user.value = unref(value)

  //Expose interface
  return {

    //Refs
    organization,
    user,

    //Mutators
    setOrganization,
    setUser,
  }
})
